module.exports = __webpack_public_path__ + "static/media/25.ee58e440.jpg";